import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

export function useFetchResult<T>(initialState: T | undefined, callback: () => Promise<T>, statesToWatch: any[], onError?: (error: any) => T) {
    const [hasFetchedResult, setFetchedResult] = useState<boolean>(false);
    const [result, setResult] = useState(initialState);
    const navigateTo = useNavigate();

    useEffect(() => {
        callback()
            .then(response => setResult(response))
            .catch(e => onError ? setResult(onError(e)) : navigateTo("/error", {replace: true}))
            .finally(() => setFetchedResult(true));
    }, statesToWatch.concat(hasFetchedResult));

    return [() => result!, hasFetchedResult, setFetchedResult] as const;
}

export default useFetchResult;